import { render, staticRenderFns } from "./salesDeliveryPlace.vue?vue&type=template&id=5b67d319&scoped=true&"
import script from "./salesDeliveryPlace.vue?vue&type=script&lang=js&"
export * from "./salesDeliveryPlace.vue?vue&type=script&lang=js&"
import style0 from "./salesDeliveryPlace.vue?vue&type=style&index=0&id=5b67d319&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b67d319",
  null
  
)

export default component.exports